// based on https://gist.github.com/tylerchilds/6ce0bb6e200b3cb797c843dc4ade425b
export const createScrollManager = function(element) {
  let callbacks = [];
  let scrollPosition;
  let animatedKilled = false;

  if (!element) return;

  const animate = () => requestAnimationFrame(onScroll);

  function onScroll() {
    if (animatedKilled) return;

    if (scrollPosition !== element.pageYOffset) {
      element.removeEventListener('scroll', animate);
      scrollPosition = element.pageYOffset;
      callbacks.forEach(cb => cb(scrollPosition));
      animate();
    } else {
      element.addEventListener('scroll', animate);
    }
  }

  animate();

  return {
    add(cb) {
      callbacks = [...callbacks, cb];
    },
    remove(cb) {
      callbacks = callbacks.filter(value => value !== cb);
    },
    destroy() {
      animatedKilled = true;
      element.removeEventListener('scroll', animate);
    },
  };
};
